import React, {Component} from 'react';
import { withTranslate } from 'react-redux-multilingual'
import HeaderCustom from "./common/headers/header-custom"
import FooterCustom from "./common/footers/footer-custom";
// ThemeSettings
import ThemeSettings from "./common/theme-settings"



class App extends Component {

    render() {
        return (
            <div>
                 <HeaderCustom logoName={'logo.png'} />
               
                {this.props.children}
                <FooterCustom logoName={'logo.png'} />
               
                {/* <ThemeSettings /> */}

            </div>
        );
    }
}

export default withTranslate(App);
